"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationPhotosStep = void 0;
const BaseUserOnboardingStep_1 = require("../../../common/domain/BaseUserOnboardingStep");
const HlOnboardingStepId_1 = require("../HlOnboardingStepId");
const validator_1 = require("@leavy/validator");
const AccommodationPhotos_1 = require("./AccommodationPhotos");
class AccommodationPhotosStep extends BaseUserOnboardingStep_1.BaseUserOnboardingStep {
    constructor() {
        super(...arguments);
        this.stepId = HlOnboardingStepId_1.HlOnboardingStepId.HL_ACCOMMODATION_PHOTOS;
    }
    getDataConstructor() {
        return AccommodationPhotos_1.AccommodationPhotos;
    }
    getDefaultData() {
        return new AccommodationPhotos_1.AccommodationPhotos();
    }
}
__decorate([
    (0, validator_1.Type)(() => AccommodationPhotos_1.AccommodationPhotos),
    __metadata("design:type", AccommodationPhotos_1.AccommodationPhotos)
], AccommodationPhotosStep.prototype, "data", void 0);
exports.AccommodationPhotosStep = AccommodationPhotosStep;
//# sourceMappingURL=AccommodationPhotosStep.js.map